import {EventBroker} from "@frontend/lib/utils/event-broker";

export const IMPORT_MAPPINGS_EVENTS = {
  INIT: 'INIT',
  IMPORTED: 'IMPORTED'
};

export const importMappingsEventBroker = new EventBroker();
